import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetContactDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface ContactSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh: boolean;
  enableSingleSelect?: boolean;
  selectedKeys?: string[];
}

export const contactForGrid = (contact: GetContactDto, lang: string) => {
  return {
    key: contact.id,
    values: {
      'contact.contactType':
        (lang === 'PL'
          ? contact.contactType?.value
          : contact.contactType?.valueEn) || '',
      'contact.email': contact.email,
    },
    isInactive: !contact.active,
  };
};

export const ContactSearch: React.FC<ContactSearchProps> = props => {
  const { t, tk } = useTranslation('clientLng');

  const columns: GridColumn[] = [
    { header: t(tk.contact.contactType), property: 'contact.contactType' },
    { header: t(tk.contact.email), property: 'contact.email' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      refresh={props.refresh}
      initialOrderColumn="contact.contactType"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.contact.noContactsForClient)}
      onRowClick={props.onRowClick}
      withHistory={false}
      enableSingleSelect={props.enableSingleSelect}
      selectedKeys={props.selectedKeys}
    />
  );
};
